import { Injectable, signal } from '@angular/core';
import { HttpService } from './http.service';
import { ApiRoutes } from '../constants/api.routes';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})

export class UserService {

    constructor(private httpService: HttpService) { }

    // shared signal
    readonly loggedInUserDetails = signal<any | undefined>(undefined);
    readonly userDetails = signal<any | undefined>(undefined);
    setLoggedInUserDetails(userDetails: any | undefined) {
        this.loggedInUserDetails.set(userDetails);
    }

    clearUserDetails() {
        this.loggedInUserDetails.set(undefined);
    }

    setUserDetails(userDetails: any | undefined) {
        this.userDetails.set(userDetails);
    }

    saveUser(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.SAVE_USER, payload);
    }

    saveUserAccess(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.SAVE_USER_ACCESS, payload);
    }

    checkUserEmail(filters: any): Observable<any> {
        const params = this.httpService.buildHttpParams(filters);
        return this.httpService.get(ApiRoutes.CHECK_USER_EMAIL, params);
    }

    getUserList(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.GET_USER_LIST, payload);
    }

    getUserById(param: any): Observable<any> {
        const params = this.httpService.buildHttpParams(param);
        return this.httpService.get(ApiRoutes.GET_USER_BY_ID, params);
    }

    getUserAccessById(param: any): Observable<any> {
        const params = this.httpService.buildHttpParams(param);
        return this.httpService.get(ApiRoutes.GET_USER_ACCESS_BY_ID, params);
    }

    reSendInvite(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.RESEND_INVITE, payload);
    }

    deleteUser(filters: any): Observable<any> {
        const params = this.httpService.buildHttpParams(filters);
        return this.httpService.post(ApiRoutes.DELETE_USER, {}, params);
    }

    reactivateUser(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.REACTIVATE_USER, payload);
    }

    getUserByEmail(param: any): Observable<any> {
        const params = this.httpService.buildHttpParams(param);
        return this.httpService.get(ApiRoutes.GET_USER_BY_EMAIL, params);
    }

    updateUserPassword(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.UPDATE_USER_PASSWORD, payload);
    }

    getLoggedInUserDetails(): Observable<any> {
        return this.httpService.get(ApiRoutes.GET_LOGGED_IN_USER_DETAILS);
    }

    saveUserProfile(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.SAVE_USER_PROFILE, payload);
    }

    exportUsers(payload: any): Observable<any> {
        return this.httpService.postPDF(ApiRoutes.EXPORT_USERS, payload);
    }

    getTransactionList(): Observable<any> {
        return this.httpService.get(ApiRoutes.GET_TRANSACTION_LIST);
    }

    updateTransaction(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.UPDATE_TRANSACTION, payload);
    }

    updateTransactionStatus(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.UPDATE_TRASNSACTION_STATUS, payload);
    }

    saveUserOrganisation(payload: any): Observable<any> {
        return this.httpService.post(ApiRoutes.SAVE_USER_ORGANISATION, payload);
    }
}